import styled from 'styled-components';

import RichText from 'components/RichText';
import BookButton from 'components/Button/BookButton';

import BREAKPOINTS from 'styles/breakpoints';
import FONTS from 'styles/fonts';
import { Grid, GridInner, columns } from 'styles/grid';
import { weight, rem } from 'styles/typography';

const Container = styled.div`
  position: relative;
  padding: 60px 0 0;
  max-width: 1200px;
  margin: 0 auto;

  ${BREAKPOINTS.medium`
    padding: 110px 0 0;
  `}
`;

const Section = styled(Grid)`
  color: ${({ color }) => color};
  max-width: 1200px;

  ${BREAKPOINTS.medium`
  ${GridInner} {
        grid-template-rows : repeat(2, auto);
    }
    padding-bottom: 110px;
  `}
`;

const Title = styled(RichText)`
  ${columns(null, 12)}
  margin-bottom: 32px;

  h2 {
    font-size: ${rem(40)};
    line-height: ${rem(50)};
    font-weight: ${weight.semibold};
  }

  p {
    margin: 0;
  }

  ${BREAKPOINTS.medium`
     ${columns(null, 5)}
    margin-bottom: 0;
    max-width: 440px;
    
    h2 {
      font-size: ${rem(50)};
      line-height: ${rem(50)};
      font-weight: ${weight.semibold};
    }
  `}

  ${BREAKPOINTS.large`
    ${columns(2, 5)}
  `}
`;

const Content = styled(RichText)`
  ${columns(null, 12)}

  em {
    font-family: ${FONTS.wulkan};
    font-weight: ${weight.bold};
  }

  ${BREAKPOINTS.medium`
    ${columns(6, 6)}
    max-width: 400px;
    margin-top: 100px;
  `}

  ${BREAKPOINTS.large`
    ${columns(7, 6)}
  `}
`;

const Cta = styled(BookButton)`
  position: relative;
  margin-left: auto;
  bottom: -30px;
  right: 30px;

  ${BREAKPOINTS.medium`
    position: absolute;
    bottom: -60px;
    right: 50px;
`};

  ${BREAKPOINTS.large`
    right: 0px;
`};
`;

const Description = ({
  descriptionOne,
  descriptionTwo,
  color,
  ctaLink,
  ctaLabel,
}) => {
  return (
    <Container>
      <Section color={color}>
        <Title html={descriptionOne?.html} />
        <Content html={descriptionTwo?.html} textIndent />
      </Section>
      <Cta size="medium" label={ctaLabel} href={ctaLink} />
    </Container>
  );
};

export default Description;
